// Provides a minimum duration until a promise resolves, possible use case
// is preventing flicker from fast API requests that are needed to display content.
export async function deferPromise<T>(p: Promise<T>, ms = 1000): Promise<T> {
  const delayPromise = new Promise<void>((resolve) => setTimeout(resolve, ms));
  const [result] = await Promise.all([p, delayPromise]);
  return result;
}
